<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <div class="filter">
          <p class="title">关联采访</p>
          <div class="selectInputer">
            <div class="keyword">
              <span @click="toggleOption()">{{selected.title || '主题'}}</span>
              <div v-if="expand" class="selects">
                <span v-for="(o, i) in options" :key="i" class="option" @click="selectOption(o)">
                  {{o.title}}
                </span>
              </div>
            </div>
            <img :src="expand ? icons.up : icons.down" alt="direct" class="direct" @click="toggleOption()">
            <input class="enter" type="text" placeholder="请输入要查找的采访" v-model="search.word" @keyup.enter="searchByWord()">
            <img src="../assets/img/interview/search.svg" alt="search" class="search" @click="searchByWord()">
          </div>
        </div>
        <img src="../assets/img/interview/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="container" ref="container">
        <empty :msg="'暂无采访数据'" v-if="list && list.length === 0" />
        <div :class="{content: true, selected: l.selected}" v-for="(l, i) in list" :key="i" @click="selectItem(l)">
          <div class="item">
            <span class="name">{{l.title}}</span>
            <span class="publiser">{{l.address}}</span>
            <span class="time">
              <span>{{l.start}}</span>
              <span>{{l.end}}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="footline">
        <div class="btn" @click="confirm()">
          关联
        </div>
        <div class="btn gray" @click="close()">
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
  name: 'withInterview',
  components: {
    empty
  },
  props: {
    from: {
      type: Number, // 来自模块
      default: 2  // 2:线索， 3:报道，4:发布
    }
  },
  data() {
    return {
      show: false,
      icons: {
        up: require('../assets/img/interview/up.png'),
        down: require('../assets/img/interview/down.png')
      },
      options: [],
      search: {
        key: '',
        word: ''
      },
      list: null,
      selected: {},
      selectedItem: {},
      expand: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: null
      },
      scrollLock: false
    }
  },
  methods: {
    toggleOption() {
      this.expand = !this.expand
    },
    selectOption(o) {
      this.selected = o
      this.search.key = o.key
      this.expand = false
    },
    close() {
      this.show = false
    },
    open() {
      this.show = true
      this.$nextTick(() => {
        this.getList()
        this.handleScroll()
      })
    },
    getList() {
      this.scrollLock = true
      if (this.page.totalPage && this.page.pageIndex > this.page.totalPage) return

      const from = this.from
      let url = ''
      if (from === 2) {
        url = apis.clue_interviews
      } else if (from === 3) {
        url = apis.Rpt_interviews
      } else if (from === 4) {
        url = apis.publish_withInterview
      } else if (from === 22) {
        url = apis.newTopicInterviewlist
      }

      const info = {
        search_option: this.search.key,
        key_words: this.search.word,
        start: '',
        end: '',
        status: '-1',
        has_material: '-1',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(url, info)
      .then((data) => {
        this.page.pageIndex += 1
        data.list.forEach(el => {
          el.selected = false
        })
        this.list = (this.list || []).concat(data.list)
        this.options = data.params.top_search.option.list
        this.selectDefault(this.options)
        this.page.totalPage = data.page.page_count
        this.scrollLock = false
      })
    },
    searchByWord() {
      // 输入搜索关键字后搜索
      this.page.pageIndex = 1
      this.page.totalPage = 1
      this.list = []
      this.getList()
    },
    selectDefault(l) {
      // 默认选中选项
      l.forEach((o) => {
        if (o.selected) {
          this.selected = o
          this.search.key = o.key
        }
      })
    },
    confirm() {
      // 回传
      const item = this.selectedItem
      let arr = []
      this.list.forEach((o) => {
        if (o.selected) {
          arr.push(o)
        }
      })
      if (arr.length == 0) {
        this.$toast('请选择采访')
        return
      }

      this.$emit('getInterview', arr)
      this.close()
    },
    selectItem(l) {
      l.selected = !l.selected
    },
    handleScroll() {
      const container = this.$refs.container
      container.addEventListener('scroll', () => {
        const scrolltop = container.scrollTop;
        const scrollheight = container.scrollHeight;
        const clientheight = container.clientHeight;

        if (scrolltop + clientheight >= scrollheight) {
          if (this.scrollLock) return
          this.getList()
        }
      }, false)
    }
  },
  mounted() {
    // this.getList()
    // this.handleScroll()
  }
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';

  .mask {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: fixed;
    z-index: 1111;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    .wrapper {
      .boxOuter;
      width: 880px;
      height: 550px;
      display: flex;
      flex-direction: column;
      .headline {
        height: 70px;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .filter {
          height: 70px;
          display: flex;
          align-items: center;
          .title {
            font-size: 24px;
            color: @dark;
            font-weight: bold;
          }
          .selectInputer {
            width: 300px;
            height: 40px;
            border-radius: 100px;
            background:rgba(185, 195, 195, 0.20);
            margin-left: 30px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            .keyword {
              color: @sub;
              font-size: 14px;
              cursor: pointer;
              white-space: nowrap;
              .selects {
                background-color: @dark;
                background-color: rgba(5, 15, 15, 0.8);
                position: absolute;
                width: 90px;
                border-radius: 4px;
                display: flex;
                flex-direction: column;
                padding: 10px 0;
                margin: 20px 0 0 -20px;
                .option {
                  color: #fff;
                  height: 30px;
                  line-height: 30px;
                  cursor: pointer;
                  padding-left: 20px;
                  &:hover {
                    background-color: @green;
                  }
                }
              }
            }
            .direct {
              margin: 0 20px 0 10px;
              cursor: pointer;
            }
            .enter {
              flex: 1;
              color: @dark;
              font-size: 14px;
              background-color: transparent;
              &::placeholder {
                color: @dateColor;
                font-size: 14px;
              }
            }
            .search {
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }
        .close {
          cursor: pointer;
        }
      }
      .container {
        flex: 1;
        overflow-y: auto;
        .content {
          padding: 0 30px;
          cursor: pointer;
          &:hover {
            background-color: rgba(185,195,195,0.15);
          }
          .item {
            height: 60px;
            border-bottom: 1px solid #dcdcdc;
            display: flex;
            align-items: center;
            .name {
              flex: 1;
              font-size: 16px;
              color: @dark;
              word-break: break-all;
            }
            .publiser {
              width: 188px;
              font-size: 14px;
              color: @dark;
              text-align: center;
            }
            .time {
              .numberFont;
              width: 130px;
              font-size: 14px;
              color: @dateColor;
              text-align: right;
              display: flex;
              flex-direction: column;
            }
          }
        }
        .content:last-child {
          .item {
            border: none;
          }
        }
        .selected {
          background-color: rgba(65,180,140,0.15) !important;
          span {
            color: @green !important;
          }
        }
      }
      .footline {
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn {
          width: 120px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 100px;
          background-color: @green;
          color: #fff;
          font-size: 14px;
          margin-right: 20px;
          cursor: pointer;
          &:active {
            .btnActive;
          }
          &:hover {
            .btnHover;
          }
        }
        .gray {
          margin-right: 0;
          background-color: @dateColor;
        }
      }
    }
  }
</style>
